export const defaultStyle = {
  footerlinsMob:
    " footer block bg-purple w-full pt-[40px] lg:pt-[85px] relative box-border leading-normal text-white text-white text-white ",
  FooterHead: " lg:pb-25 py-25 lg:py-auto lg:w-3/4  w-[87%]  mx-auto ",
  footerWrap: "footerWrap max-w-xl mx-auto px-[35px] lg:px-15",
  footerLogo: "footer-logo max-w-xl mx-auto px-[35px] lg:px-15",
  fatFooter: "footer-menu-wrapper lg:flex md:flex md:justify-between text-center lg:text-left",
  copyrightContainer:
    "text-[10px] tracking-[0.45px] font-Bold md:font-Regular lg:font-Regular md:text-[18px]",
  bottomFooter:
    " footerTwo lg:pb-[40px] lg:flex md:flex lg:pt-[100px] md:pt-[50px] lg:max-w-lg xl:max-w-xl mx-auto px-15",
  bottomFooter2: "text-center md:text-left lg:text-left lg:w-[40%]",
  bottomSideFooter: "pb-[25px] lg:pb-[0px] lg:flex-1 lg:w-[60%]",
  SocialLinkWrapper:
    "SocialLinkWrapper md:flex lg:flex lg:max-w-lg xl:max-w-xl mx-auto px-35 lg:px-15 mb-[40px] lg:mb-0",
  SocialLinkLeft: "SocialLinkLeft flex-1 hidden lg:block md:block",
  Social: "footer-col lg:flex md:flex flex-col lg:w-[18%] md:w-[18%]",
  upliftBtn: "upliftBtn",
  upliftBtnMobile: "upliftBtnMobile fixed top-auto right-[20px] lg:right-[50px] bottom-[120px] z-100",
  upliftBtnTablet: "upliftBtnTablet fixed top-auto right-[20px] lg:right-[50px] bottom-[120px] z-100",
}
